import React from 'react';

export const CardSkeleton = () => (
  <div className="rounded-xl border border-gray-200 bg-white overflow-hidden">
    <div className="skeleton aspect-square w-full" />
    <div className="p-4 space-y-2">
      <div className="skeleton h-4 w-1/3 rounded" />
      <div className="skeleton h-4 w-5/6 rounded" />
      <div className="skeleton h-4 w-1/2 rounded" />
    </div>
  </div>
);

export const GridSkeleton = ({ count = 8 }) => (
  <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4">
    {Array.from({ length: count }).map((_, i) => (
      <CardSkeleton key={i} />
    ))}
  </div>
);

export const ItemSkeleton = () => (
  <div className="grid grid-cols-1 md:grid-cols-2 gap-8 p-4 md:p-8">
    <div className="skeleton aspect-square w-full rounded-xl" />
    <div className="space-y-4">
      <div className="skeleton h-6 w-2/3 rounded" />
      <div className="skeleton h-4 w-1/3 rounded" />
      <div className="skeleton h-8 w-1/4 rounded" />
      <div className="skeleton h-24 w-full rounded" />
    </div>
  </div>
);

export default GridSkeleton;
